import React, { useCallback } from 'react'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { FullScreenErrorWall } from '@/src/components/ui/FullScreenErrorWall'
import { QuerySuspenseBoundary } from '@/src/components/ui/QuerySuspenseBoundary'
import { ScreenLoadingFallback } from '@/src/components/ui/ScreenLoadingFallback'
import { captureException } from '@/src/utils/sentry'
import { useTranslation } from 'react-i18next'

import { VoiceAssessmentIntroRoute } from './VoiceAssessmentIntroRoute'

export default function VoiceAssessmentIndexRoute() {
  const { t } = useTranslation(['onboarding', 'common'])
  const { back, canGoBack, replace } = useRouter()
  const { source } = useLocalSearchParams<{
    source?: string | string[]
  }>()
  const rawSource = Array.isArray(source) ? source[0] : source
  const isOnboardingEntry = rawSource === 'onboarding'

  const navigateAway = useCallback(() => {
    if (isOnboardingEntry) {
      replace('/(protected)/(account)/(tabs)')
      return
    }

    if (canGoBack()) {
      back()
      return
    }

    replace('/(protected)/(account)/(tabs)')
  }, [back, canGoBack, isOnboardingEntry, replace])

  return (
    <QuerySuspenseBoundary
      loadingFallback={<ScreenLoadingFallback />}
      errorFallback={({ reset }) => (
        <FullScreenErrorWall
          title={t('onboarding:voice_assessment.load_definition_failed_title')}
          message={t(
            'onboarding:voice_assessment.load_definition_failed_message',
          )}
          primaryActionLabel={t('common:error_try_again')}
          onPrimaryAction={reset}
          secondaryActionLabel={t('onboarding:voice_assessment.skip_cta')}
          onSecondaryAction={navigateAway}
        />
      )}
      onError={(error) =>
        captureException(error, {
          feature: 'voice-assessment',
          tags: { action: 'load_voice_assessment_definition' },
        })
      }
    >
      <VoiceAssessmentIntroRoute isOnboardingEntry={isOnboardingEntry} />
    </QuerySuspenseBoundary>
  )
}
